<template>
    <div>
        <el-drawer title="通知详情" :visible.sync="drawerShow" :wrapperClosable="false" :destroy-on-close="true"
            size="450px"  @close="close">
            <div class="drawer-content" v-loading="dataLoading">
                <table v-if="data" class="info-table" width="100%">
                    <tr>
                        <th width="80">通知类型</th><td><div v-if="data.type == 0">疫情防控提示</div></td>
                    </tr>
                    <tr>
                        <th>演出</th><td>{{data.activity}}</td>
                    </tr>
                    <tr>
                        <th>通知名称</th><td>{{data.name}}</td>
                    </tr>
                    <tr>
                        <th>通知内容</th><td>{{data.content}}</td>
                    </tr>
                    <tr>
                        <th>通知人数</th><td>{{data.num}}</td>
                    </tr>
                    <tr>
                        <th>通知人</th><td>{{data.createUserName}}</td>
                    </tr>
                    <tr>
                        <th>通知时间</th><td>{{data.createTime}}</td>
                    </tr>
                </table>
            </div>
            <div class="drawer-footer">
                <el-button @click="close">关闭</el-button>
            </div>
        </el-drawer>
    </div>
</template>

<script>
export default {
    data(){
        return{
            drawerShow:false,
            data: null,
            dataLoading: false,
            id: ""
        }
    },
    methods:{
        show(id){
            this.id = id;
            this.getDetail();
            this.drawerShow = true;
        },
        close(){
            this.drawerShow = false;
        },
        async getDetail(){
            this.dataLoading = true;
            const res = await this.$request({
                url: '/message/notify/detail',
                method: 'post',
                params: {id: this.id}
            }).catch(() => {
                return {data: {state: '0', msg: '请求错误'}};
            }).finally(() => {
                this.dataLoading = false;
            });
            const { state , result,  msg } = res.data;
            if(state == 1 && result){
                this.data = result;
            }else{
                this.data = null;
                this.$message.error(msg || '请求错误');
            }
        }
    }
}
</script>